import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginModel } from 'src/app/model/login.model';
import { Member } from 'src/app/model/member.model';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<Member>;
  public currentMember: Observable<Member>;
  constructor(private tokenService: TokenService) {
    this.setTokenToSubject();
  }
  login(loginResult:any) {
    this.storeTokenInLocal(loginResult);
  }
  logout() {
    // remove user from local storage to log user out
    this.tokenService.removeToken('currentUser');
    this.currentUserSubject.next(new Member());
  }
  storeTokenInLocal(model: LoginModel) {
    // login successful if there's a jwt token in the response
    if (!!model) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      this.tokenService.writeToken('currentUser', model.Token);

      this.currentUserSubject.next(model.User);
    }
  }
  isLogin() {
    return this.tokenService.decodeToken('currentUser');
  }
  setTokenToSubject() {
    var decode = this.tokenService.decodeToken('currentUser');
    
    var member = decode ? { UserID: decode.unique_name } : {};
    
    this.currentUserSubject = new BehaviorSubject<any>(member);
    this.currentMember = this.currentUserSubject.asObservable();
  }
}
